import { dateFormat } from "~/shared/lib/DateFormat/dateFormat";

import { useFormIProps } from ".";

export const toServer = (
  data: useFormIProps,
  count?: string,
  page?: string,
) => {
  const params = new URLSearchParams();

  if (data.dealerSelect && data.dealerSelect.length > 0) {
    data.dealerSelect.forEach((dealer) => {
      params.append("dealerSearch[ids][]", String(dealer.value));
    });
  }

  params.append("count", count ?? "25");
  params.append("page", page ?? "0");
  if (data.actStatus && data.actStatus.length > 0) {
    data.actStatus.forEach((status) =>
      params.append("actStatus[]", status.value),
    );
  }

  if (data.dateFrom) {
    const startDate = dateFormat(data.dateFrom, { type: "ISO" });
    startDate && params.append("startDate", startDate);
  }
  if (data.dateTo) {
    const endDate = dateFormat(data.dateTo, { type: "ISO" });
    endDate && params.append("endDate", endDate);
  }

  const queryString = params.toString();

  return queryString;
};
